var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"margin":"0px","padding":"0px","max-width":"100%"}},[(_vm.title != null)?_c('v-app-bar',{style:({ 
      position: 'fixed',
      top: '50px',
      right: 0,
      width: '100%',
      border: '3px solid #73AD21'
    }),attrs:{"color":"indigo","dark":"","dense":""}},[_c('v-spacer'),_c('v-toolbar-title',[_c('h3',[_vm._v("Policy Documents ("+_vm._s(_vm.title)+")")])]),_c('v-icon',{staticStyle:{"padding-left":"10px"},on:{"click":_vm.close}},[_vm._v("mdi-close")])],1):_vm._e(),_c('div',{staticStyle:{"padding-top":"20px"}}),_c('div',{staticStyle:{"margin":"40px"},domProps:{"innerHTML":_vm._s(_vm.html)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }